import React, { useSyncExternalStore } from "react";
import mixpanel from "mixpanel-browser";
import { OKELink, UI_CAPTION } from "oolib";
import { MIXPANEL_EVENTS_NAMING } from "@/mixpanel/MIXPANEL_EVENTS_NAMING";

/**
 * The Highlights listing's layout: the observations table (default) or the
 * earlier masonry card grid. Remembered per browser (localStorage) and held
 * in one tiny store, because the switch link sits on the page header
 * (SM_Analysis) while the listing that reads it sits two components below.
 */
const STORAGE_KEY = "annoExplorer_layout";
const DEFAULT_LAYOUT = "table";
const listeners = new Set();

const read = () => {
  try {
    return window.localStorage.getItem(STORAGE_KEY) || DEFAULT_LAYOUT;
  } catch {
    return DEFAULT_LAYOUT;
  }
};
let current = typeof window === "undefined" ? DEFAULT_LAYOUT : read();

const setLayout = (next) => {
  current = next;
  try {
    window.localStorage.setItem(STORAGE_KEY, next);
  } catch {}
  listeners.forEach((fn) => fn());
};
const subscribe = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};

/** "table" | "cards" */
export const useAnnoExplorerLayout = () => useSyncExternalStore(subscribe, () => current, () => DEFAULT_LAYOUT);

/** The "Switch to old / new layout" link for the Highlights header. */
export const AnnoExplorerLayoutSwitch = () => {
  const layout = useAnnoExplorerLayout();
  const showCards = layout === "cards";
  const switchLayout = () => {
    const next = showCards ? "table" : "cards";
    mixpanel.track(MIXPANEL_EVENTS_NAMING.ANNO_LAYOUT_SWITCHED.eventName, {
      [MIXPANEL_EVENTS_NAMING.ANNO_LAYOUT_SWITCHED.properties.FEATURE]: "Annotation Explorer",
      [MIXPANEL_EVENTS_NAMING.ANNO_LAYOUT_SWITCHED.properties.LAYOUT]: next,
    });
    setLayout(next);
  };
  return (
    <OKELink color="black" onClick={switchLayout}>
      <UI_CAPTION>{showCards ? "Switch to new layout" : "Switch to old layout"}</UI_CAPTION>
    </OKELink>
  );
};
